import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';

import { auth } from './utils/authToken';
import config from './config/config.json';
const { dbProtocol, dbHost, dbPort, dbPathGraphQl } = config[
  process.env.REACT_APP_DIST_ENV
];

const dbUri = `${dbProtocol}://${dbHost}:${dbPort}/${dbPathGraphQl}`;

const cache = new InMemoryCache();

const httpLink = new HttpLink({
  uri: dbUri,
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = auth.getToken('jwtToken');
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : {},
    },
  };
});

/* 
  Disable cache so it reflects the updates
  If you're just displaying data and not mutating them you can remove it
  to increase performance
*/
const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'network-only',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  },
};

const client = new ApolloClient({
  cache: cache,
  link: authLink.concat(httpLink),
  defaultOptions: defaultOptions,
});

export default client;



// WEBPACK FOOTER //
// ./src/apolloClient.js